import { Component } from 'react';
import {
  FaLinkedin,
  FaFileAlt,
  FaBriefcase,
  FaInstagram,
  FaRobot,
  FaChalkboardTeacher,
} from 'react-icons/fa';
import Header from '../Header';
import Footer from '../Footer';
import './index.css';

class About extends Component {
  render() {
    return (
      <div className="main-container">
        <Header />
        <div className="page-content">
          <h2 className="section-heading">About Me</h2>
          <p className="section-subheading">
            B.Tech graduate (2026) · Full-stack &amp; AI developer · Educator · Actively seeking opportunities
          </p>

          <div className="about-card glass-card">
            <p className="about-summary">
              I&apos;m <strong>Naveen Janapati</strong>, a full-stack developer with hands-on experience building
              web applications, LLM-powered solutions, and educational content. I completed my B.Tech in 2026 from
              Vasireddy Venkatadri Institute of Technology (VVIT), Guntur. I love teaching — whether through
              one-on-one tutoring, Instagram content, or solving problems as a Subject Matter Expert.
            </p>

            <div className="about-section">
              <h3 className="about-section-title">
                <FaBriefcase className="section-icon" />
                Work Experience
              </h3>
              <div className="experience-card">
                <div className="experience-header">
                  <h4 className="experience-role">Subject Matter Expert — Computer Science</h4>
                  <span className="experience-duration">5 Months</span>
                </div>
                <p className="experience-company">Chegg</p>
                <p className="experience-detail">
                  Solved computer science problems across programming, algorithms, data structures, and core CS
                  concepts. Delivered accurate, well-explained solutions for students worldwide — sharpening both
                  my technical depth and communication skills.
                </p>
              </div>
            </div>

            <div className="about-section">
              <h3 className="about-section-title">
                <FaInstagram className="section-icon" />
                Content Creator &amp; Educator
              </h3>
              <div className="experience-card">
                <p className="experience-detail">
                  I run an Instagram page with <strong>6,000+ followers</strong>, where I teach Python concepts
                  and have covered <strong>20+ coding problems</strong> in an easy-to-understand format.
                  Teaching is not just a side activity for me — it&apos;s something I genuinely love and excel at.
                </p>
              </div>
            </div>

            <div className="about-section">
              <h3 className="about-section-title">
                <FaRobot className="section-icon" />
                AI &amp; LLM Skills
              </h3>
              <div className="experience-card">
                <p className="experience-detail">
                  Beyond traditional full-stack work, I build and experiment with <strong>LLM applications</strong>,
                  <strong> RAG (Retrieval-Augmented Generation)</strong> pipelines, and <strong>AI agents</strong>
                  — ready to help clients integrate intelligent features into their products.
                </p>
              </div>
            </div>

            <div className="about-section">
              <h3 className="about-section-title">
                <FaChalkboardTeacher className="section-icon" />
                Education
              </h3>
              <ul className="journey-list">
                <li>
                  <span className="journey-label">B.Tech — Completed 2026</span>
                  <span>Vasireddy Venkatadri Institute of Technology (VVIT), Guntur</span>
                </li>
                <li>
                  <span className="journey-label">EAPCET Rank</span>
                  <span>Secured 10,025 and joined VVIT through counseling.</span>
                </li>
                <li>
                  <span className="journey-label">10+2</span>
                  <span>Completed in Ongole, Andhra Pradesh.</span>
                </li>
                <li>
                  <span className="journey-label">Native Place</span>
                  <span>Ongole — famous for its Ongole bulls.</span>
                </li>
              </ul>
            </div>

            <div className="about-section">
              <h3 className="about-section-title">What I&apos;m Looking For</h3>
              <div className="opportunity-tags">
                <span className="opportunity-tag">Full-Time Jobs</span>
                <span className="opportunity-tag">Internships</span>
                <span className="opportunity-tag">Freelance Projects</span>
                <span className="opportunity-tag">Contract Work</span>
                <span className="opportunity-tag">Python Tutoring</span>
                <span className="opportunity-tag">Technical Content</span>
              </div>
              <p className="about-summary opportunity-note">
                Whether you need a developer for a freelance project, a tutor for Python, or a team member
                who can build AI-powered features — I&apos;m ready to deliver. Fast response, clear communication,
                and quality work.
              </p>
            </div>

            <div className="cta-container">
              <button
                type="button"
                className="btn-primary"
                onClick={() => window.open('https://www.linkedin.com/in/venkata-naveen-kumar-janapati/', '_blank')}
              >
                <FaLinkedin />
                Connect on LinkedIn
              </button>
              <button
                type="button"
                className="btn-secondary"
                onClick={() => window.open('/certificates/Venkata-Naveen-Kumar-Janapati-Resume.pdf')}
              >
                <FaFileAlt />
                Download Resume
              </button>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default About;
